import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CriteriaService } from 'src/app/services/config/criteria.service';
import { UnitsService } from 'src/app/services/config/units.service';
import {ActivatedRoute, Router} from "@angular/router";
import {UserService} from "../../../../services/user.service";

@Component({
    selector: 'app-multicriteria-responses-explain',
    templateUrl: './multicriteria-responses-explain.component.html',
    styleUrls: ['./multicriteria-responses-explain.component.scss'],
    standalone: false
})
export class MulticriteriaResponsesExplainComponent implements OnInit {

  @Input() allDecisionInfo: any;
  @Input() evaluationSessionId;

  loading: boolean = false;


  team_member: any;
  evaluation_session: any;
  response_stamps: any;
  decision_table:any;
  organization:any
  primary_target: any = [];
  secondary_target: any = [];
  framework_criteria: any = [];
  proposals: any = [];
  evaluations: any = [];
  skipInstructions = false;
  numOfCriteriaQuantitative: number = 0;
  numOfCriteriaQualitative: number = 0;

  // Variabili per slider display (solo visualizzazione)
  displaySliderValue1 = 48;
  displaySliderValue2 = 20;
  displaySliderValue3 = 63;
  displaySliderValue4 = 83;

  constructor(private activeRoute: ActivatedRoute, private router: Router, private userService: UserService, private unitService: UnitsService, private criteriaService: CriteriaService) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges) {

    this.loading = true;
    if (this.allDecisionInfo) {

      this.team_member = this.allDecisionInfo.team_member;
      this.evaluation_session = this.allDecisionInfo.evaluation_session;
      this.response_stamps = this.allDecisionInfo.response_stamps;
      this.decision_table = this.allDecisionInfo.decision_table;
      this.organization = this.allDecisionInfo.decision_table.organization;
      this.primary_target = this.allDecisionInfo.primary_target;
      this.secondary_target = this.allDecisionInfo.secondary_target;
      this.framework_criteria = this.allDecisionInfo.framework_criteria;
      this.proposals = this.allDecisionInfo.proposals;
      this.evaluations = this.allDecisionInfo.evaluations;

      this.init();
    }
    this.loading = false;

    // this.doSomething(changes.categoryId.currentValue);

  }

  init() {
    if (this.userService?.currentOrganization?.customs?.profile === 'alexion') {
      this.goToEvaluation();
    }

    const skipInstructions = JSON.parse(localStorage.getItem('skipInstructions')) || [];
    const userId = this.userService.userDetails.id;
    this.skipInstructions = skipInstructions.find(instruction => {
      return instruction?.id === userId && instruction?.multicriteria === true;
    });

    if (this.skipInstructions){
      // this.router.navigate(['../weight-target'], { relativeTo: this.activeRoute });
      // this.router.navigate(['../responses-evaluation'], { relativeTo: this.activeRoute });
      this.router.navigate(['../weight-criteria'], { relativeTo: this.activeRoute });
    }

    this.loading = true;

    //  setto le confidence per i criteri di ogni proposta
    for (let proposal of this.proposals) {
      for (let criteria of proposal.criteria) {
        let response = this.evaluations.answers.find(x => x.criteria_id == criteria.id);
        if (response) {
          criteria.answer = response;
        } else {
          criteria.answer = { confidence: '-' }
        }
      }
    }

    //  setto il numero dei criteri da valutare
    if (this.proposals.length > 0) {
      this.numOfCriteriaQualitative = this.proposals[0].criteria.filter(x => this.criteriaService.criteriaIsQualitative(x.typology)).length;
      this.numOfCriteriaQuantitative = this.proposals[0].criteria.filter(x => this.criteriaService.criteriaIsQuantitative(x.typology)).length;
    }

    this.loading = false;
  }



  getUnitsService() {
    return this.unitService;
  }

  getCriteriaService() {
    return this.criteriaService;
  }

  goToEvaluation() {
    const skipInstructions = JSON.parse(localStorage.getItem('skipInstructions')) || [];

    const userId = this.userService.userDetails.id;
    const foundIndex = skipInstructions.findIndex(instruction => instruction.id === userId);

    if (foundIndex !== -1) {
      skipInstructions[foundIndex].multicriteria = true;
    } else {
      const newInstruction = {
        id: userId,
        consensus: false,
        multiobjective: false,
        multicriteria: true,
      };
      skipInstructions.push(newInstruction);
    }
    localStorage.setItem('skipInstructions', JSON.stringify(skipInstructions));

    // this.router.navigate(['../weight-target'], { relativeTo: this.activeRoute });
    this.router.navigate(['../weight-criteria'], { relativeTo: this.activeRoute });
  }

}
